import axios from 'axios';
/**
 * テンプレートにパラメータを埋め込んだ文字列を返します。
 * @param template テンプレート文字列
 * @param params パラメータ (オブジェクトまたは配列)
 * @param widthHtmlEncode HTMLエンコードを行うかどうか
 * @returns テンプレートにパラメータを埋め込んだ文字列
 */
export function applyTemplate(template, params) {
    let formatRe, formatReNum = /\{(\d+)\}/g, // 数値ベースの置換用
    formatReWord = /\{([^\d]\w*)\}/g; // 文字ベースの置換用
    // 文字列が単一の場合、配列に変換
    if (typeof params === "string") {
        params = [params];
    }
    // paramsが配列かオブジェクトかによって正規表現を変更
    if (Array.isArray(params)) {
        formatRe = formatReNum;
    }
    else {
        formatRe = formatReWord;
    }
    return template.replace(formatRe, function (match, index) {
        let val = params[index];
        if (val === null || val === undefined) {
            return "";
        }
        return val;
    });
}
/**
 * 指定されたfileNameからHTMLデータを非同期に取得します。
 * @param fileName ファイル名
 * @returns 取得したHTMLデータのPromise
 */
export async function getHtml(fileName) {
    const date = new Date();
    const dateParam = `${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}`;
    const url = `/html${fileName}`;
    try {
        console.log('Attempting to load HTML from URL:', url);
        const response = await axios.get(url);
        console.log('HTML loaded successfully, length:', response.data.length);
        return response.data; // response.dataにHTMLコンテンツが含まれています
    }
    catch (error) {
        console.error('Failed to load HTML:', error);
        console.error('URL that failed:', url);
        return null; // エラーハンドリングを適切に行う
    }
}
